// Keep in sync with ConsentCategory.PERFORMANCE in
// public/assets/js/analytics/utilities.ts.
const PERFORMANCE_CATEGORY = 'C0002';

const readCookie = (name: string, cookieString: string) => {
  const match = cookieString
    .split(';')
    .map((part) => {
      return part.trim();
    })
    .find((part) => {
      return part.startsWith(`${name}=`);
    });
  return match?.slice(name.length + 1);
};

/**
 * True when the `OptanonConsent` cookie (for example
 * `...&groups=C0001%3A1%2CC0002%3A0...`) has the PERFORMANCE category on.
 * False on a first visit, before OneTrust writes the cookie. Never throws,
 * since it runs before Sentry and the app boot.
 */
export const hasPerformanceConsentCookie = (
  cookieString = typeof document === 'undefined' ? '' : document.cookie,
): boolean => {
  try {
    const consent = readCookie('OptanonConsent', cookieString);
    if (!consent) {
      return false;
    }
    const groups = new URLSearchParams(consent).get('groups') ?? '';
    return groups.split(',').includes(`${PERFORMANCE_CATEGORY}:1`);
  } catch {
    return false;
  }
};
